import { compose, propEq, find } from 'ramda'

export const getUpgradePopupProfileMessage = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_PROFILE_MSG'))
)
